import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';
import { AttendingListComponent } from './component/attending-list/attending-list.component';
import { AttendingService } from './service/attending.service';
import { ScreeningComponent } from './component/screening/screening.component';
import { ConfigurationComponent } from './component/configuration/configuration.component';
import { SchedulingComponent } from './component/scheduling/scheduling.component';
import { MonitoringComponent } from './component/monitoring/monitoring/monitoring.component';
import { DispatchComponent } from './component/dispatch/dispatch.component';
import { AttendingComponent } from './component/attending/attending.component';
import { ScreeningService } from './service/screening.service';
import { DispatchService } from './service/dispatch.service';
import { AccessoryModule } from '../accessory/accessory.module';
import { DiagnosisModule } from '../diagnosis/diagnosis.module';
import { ShowAttendingComponent } from './component/show-attending/show-attending.component';
import { ValidationComponent } from './component/validation/validation.component';
import { TechnicianLocationComponent } from './component/technician-location/technician-location.component';
import { TechnicianScoreComponent } from './component/technician-score/technician-score.component';
import { FinishAttendingComponent } from './component/finish-attending/finish-attending.component';
import { MonitoringStepComponent } from './component/monitoring/step/monitoring-step.component';
import { MonitoringFileComponent } from './component/monitoring/monitoring-file/monitoring-file.component';
import { MonitoringPreEvaluationComponent } from './component/monitoring/monitoring-pre-evaluation/monitoring-pre-evaluation.component';
import { MonitoringValidationComponent } from './component/monitoring/monitoring-validation/monitoring-validation.component';
import { MonitoringConclusionComponent } from './component/monitoring/monitoring-conclusion/monitoring-conclusion.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    MaterializeModule,
    AccessoryModule,
    DiagnosisModule
  ],
  exports: [
    AttendingListComponent,
    ScreeningComponent,
    ConfigurationComponent,
    SchedulingComponent,
    MonitoringComponent,
    DispatchComponent,
    ShowAttendingComponent,
    TechnicianLocationComponent,
    TechnicianScoreComponent,
    FinishAttendingComponent,
    MonitoringStepComponent,
    MonitoringFileComponent,
    MonitoringPreEvaluationComponent,
    MonitoringValidationComponent,
    MonitoringConclusionComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AttendingListComponent,
    ScreeningComponent,
    ConfigurationComponent,
    SchedulingComponent,
    MonitoringComponent,
    DispatchComponent,
    AttendingComponent,
    ShowAttendingComponent,
    ValidationComponent,
    TechnicianLocationComponent,
    TechnicianScoreComponent,
    FinishAttendingComponent,
    MonitoringStepComponent,
    MonitoringFileComponent,
    MonitoringPreEvaluationComponent,
    MonitoringValidationComponent,
    MonitoringConclusionComponent
  ],
  providers: [
    AttendingService,
    ScreeningService,
    DispatchService
  ]
})
export class AttendingModule { }



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/attending.module.ts